import React from 'react';
import { ArrowRight } from 'lucide-react';
const PRIORITY_CARDS = [{
  name: 'Complete Mailbox & Post Systems',
  href: '/6m8/mailboxes/complete-mailbox-post-system.html',
  desc: 'Everything you need in one matching package.',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fgaines%2F2024+images%2FWM3.jpg&h=150&site=6153&user=4145&v=1&w=150' // Placeholder using available image
}, {
  name: 'Commercial Mailboxes & Lockers',
  href: '/6m8/commercial-mailboxes-lockers.html',
  desc: 'USPS approved multi-tenant delivery.',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=150&site=6153&user=4145&v=1&w=150'
}, {
  name: 'Replacement Parts',
  href: '/6m8/mailboxes/mailbox-replacement-parts.html',
  desc: 'Doors, locks, keys, and hardware.',
  imgPlaceholder: <svg viewBox="0 0 100 100" className="w-12 h-12 text-brand-green/80" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-304">
        <path d="M40 60l20-20" data-id="element-305" />
        <circle cx="65" cy="35" r="10" data-id="element-306" />
        <path d="M35 65l-5 5 10 10 5-5" data-id="element-307" />
      </svg>
}];
const SUPPORTING_CARDS = [{
  name: 'Wall Mount Mailboxes',
  href: '/6m8/mailboxes/wall-mount-mailboxes.html'
}, {
  name: 'Locking Mailboxes',
  href: '/6m8/mailboxes/locking-mailboxes.html'
}, {
  name: 'Mailbox Posts',
  href: '/6m8/mailbox-posts.html'
}, {
  name: 'Address Plaques & Numbers',
  href: '/6m8/address-plaques-and-house-numbers.html'
}, {
  name: 'Street Signs & Traffic Signs',
  href: '/6m8/street-signs-traffic-signs.html'
}, {
  name: 'Lighting',
  href: '/6m8/lighting.html'
}];
export function PopularPaths() {
  return <section className="py-16 lg:py-24 bg-white border-y border-brand-border" data-id="element-308">
      <div className="max-w-7xl mx-auto px-4" data-id="element-309">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4" data-id="element-310">
          <div className="max-w-2xl" data-id="element-311">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-312">
              Popular shopping paths
            </h2>
            <p className="text-gray-600 text-lg" data-id="element-313">
              Organized around real buying decisions, not just a long category
              tree.
            </p>
          </div>
          <a href="/29.html" className="hidden md:flex items-center text-brand-green font-semibold hover:text-brand-red transition-colors" data-id="element-314">
            View all categories <ArrowRight size={16} className="ml-2" data-id="element-315" />
          </a>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6" data-id="element-316">
          {/* Priority Cards */}
          {PRIORITY_CARDS.map(cat => <a key={cat.name} href={cat.href} className="group flex flex-col bg-brand-cream rounded-xl border border-brand-border overflow-hidden hover:border-brand-green/50 hover:shadow-sm transition-all" data-id="element-317">
              <div className="h-40 bg-white flex items-center justify-center border-b border-brand-border/50 p-4" data-id="element-318">
                <div className="transform group-hover:scale-105 transition-transform duration-300 h-full w-full flex items-center justify-center" data-id="element-319">
                  {cat.image ? <img src={cat.image} alt={cat.name} className="h-full w-auto object-contain mix-blend-multiply" data-id="element-320" /> : cat.imgPlaceholder}
                </div>
              </div>
              <div className="p-6" data-id="element-321">
                <h3 className="font-serif font-bold text-lg text-brand-charcoal mb-1 group-hover:text-brand-green transition-colors" data-id="element-322">
                  {cat.name}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-323">{cat.desc}</p>
              </div>
            </a>)}
        </div>

        {/* Supporting Cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-324">
          {SUPPORTING_CARDS.map(cat => <a key={cat.name} href={cat.href} className="group bg-white rounded-lg border border-brand-border p-4 text-center hover:border-brand-green/50 hover:bg-brand-cream transition-all flex items-center justify-center min-h-[80px]" data-id="element-325">
              <h3 className="font-medium text-brand-charcoal text-sm group-hover:text-brand-green transition-colors leading-snug" data-id="element-326">
                {cat.name}
              </h3>
            </a>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-327">
          <a href="/29.html" className="inline-flex items-center justify-center w-full bg-white text-brand-charcoal font-semibold py-3 rounded-md border border-brand-border hover:border-brand-green hover:bg-brand-cream transition-colors" data-id="element-328">
            View all categories
          </a>
        </div>
      </div>
    </section>;
}